import { AxiosResponse } from 'axios';

import { instance as axios } from 'api/axios';
import { BranchData, BranchEditing } from './interfaces';

export class BranchService {
  static prefix = '/Branch';

  public static async getBranches() {
    try {
      const url = `${BranchService.prefix}`;
      const response: AxiosResponse<BranchData[]> = await axios.get(url);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async getBranchId(id: string) {
    try {
      const url = `${BranchService.prefix}/Info`;
      const response: AxiosResponse<BranchEditing> = await axios.get(url, {
        params: {
          branchId: id,
        },
      });

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async putBranchInfo(data: FormData) {
    try {
      const url = `${BranchService.prefix}/Info`;
      const response: AxiosResponse<BranchEditing> = await axios.put(url, data);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async postNewBranch(data: FormData) {
    try {
      const url = `${BranchService.prefix}/Info`;
      const response: AxiosResponse<BranchEditing> = await axios.post(url, data);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }

  public static async deleteBranchInfo(branchId: number, isDeleted: boolean) {
    try {
      const url = `${BranchService.prefix}`;
      const response: AxiosResponse<BranchEditing> = await axios.put(url, {}, { params: { branchId, isDeleted } });

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
